import { Co2, FoodRescue, Meals, Money } from '../MeshIcon'

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]
/**
 * used with demoMode state in App component. Toggles labels to mask as Diversion Tracker SaaS product
 */

export const demoNavMapping = {
  dashboard: { demoLabel: 'Admin Dashboard', label: 'Dashboard' },
  clientApp: { demoLabel: 'Client Dashboard', label: 'Client App' },
  receivers: { demoLabel: 'Vendors', label: 'Receivers' },
  stores: { demoLabel: 'Service Locations', label: 'Stores' },
  nopickup: { demoLabel: 'Service Issues', label: 'BulkScans' },
  stipened: { demoLabel: 'Vendor Performance', label: 'Stipened Report' },
  mailable: { demoLabel: 'Donations', label: 'Mailable Contacts' },
  transcripts: { demoLabel: 'Communication Log', label: 'Call Transcripts' },
  platform: { demoLabel: 'Diversion Platform', label: 'Ops Platform' },
  community: { demoLabel: 'Service Map', label: 'Community Portal' }
}
export const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
export const tokenInsert = (token, addons) => (addons ? ';' + addons + ';mesh-end;' : '') + token
export const diffBetweenDates = (date1, date2) => {
  const diffTime = Math.abs(date2 - date1)
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  return diffDays
}
export const getTotalWeightFromResults = (results, weightKey = 'weight_kg__sum') => {
  let kgTotal = 0
  let kgCharity = 0
  results.forEach((result) => {
    kgTotal += result[weightKey]
    if (result.destination_id && result.destination_id === 1) {
      kgCharity += result[weightKey]
    }
  })
  return { kgTotal: kgTotal, kgCharity: kgCharity }
}
export const getTotalByKeyFromResults = (results, keys = []) => {
  let itemKeys = {}
  keys.forEach((key) => {
    itemKeys[key] = 0.0
  })
  results.forEach((result) => {
    keys.forEach((key) => {
      if (result[key] !== undefined) {
        itemKeys[key] += result[key]
      }
    })
  })
  return itemKeys
}
export const calculateImpactMetrics = (
  kgForCharity = 0,
  kgAllDestinations = 0,
  options = { showMoneySaved: false },
  apiValues = {}
) => {
  const metrics = [
    {
      id: 'meals',
      name: 'Meals provided',
      value: apiValues['meals_provided__sum'] || 0, // kgForCharity / 0.544,
      unit: '',
      color: 'mesh-accent-blue',
      Icon: Meals
    },
    {
      id: 'donatedValue',
      name: 'Food rescued',
      value: apiValues['food_rescued_kg__sum'] || 0, //kgAllDestinations,
      unit: 'kg',
      color: 'mesh-accent-red',
      Icon: FoodRescue
    },
    {
      id: 'co2',
      name: 'CO2e reduced (KG)',
      value: apiValues['co2_emissions_kg__sum'] || 0, //kgAllDestinations * 2.58
      unit: 'kg',
      color: 'mesh-yellow-1',
      Icon: Co2
    }
  ]
  options.showMoneySaved &&
    metrics.push({
      id: 'moneySaved',
      name: 'Donated value',
      value: apiValues['money_saved__sum'] || 0, //kgForCharity * 5.7,
      unit: '$',
      color: 'mesh-green-3',
      Icon: Money
    })
  return metrics
}
export const calculateImpactMetricsSP = (
  kgForCharity = 0,
  kgAllDestinations = 0,
  options = { showMoneySaved: false },
  apiValues = {}
) => {
  const metrics = [
    {
      id: 'labels',
      name: '',
      value: 0, // kgForCharity / 0.544,
      unit: '',
      color: 'white',
      bgcolor: 'white',
      Icon: ''
    },{
      id: 'meals',
      name: 'meals provided',
      value: apiValues['meals_provided__sum'] || 0, // kgForCharity / 0.544,
      unit: '',
      color: 'mesh-green-1',
      bgcolor: '#d1dbd8',
      Icon: Meals
    },
    {
      id: 'donatedValue',
      name: 'food rescued',
      value: apiValues['food_rescued_kg__sum'] || 0, //kgAllDestinations,
      unit: 'kg',
      color: 'mesh-green-2',
      bgcolor: '#cde4d8',
      Icon: FoodRescue
    },
    {
      id: 'co2',
      name: 'CO2e reduced',
      value: apiValues['co2_emissions_kg__sum'] || 0, //kgAllDestinations * 2.58
      unit: 'kg',
      color: 'mesh-green-3',
      bgcolor: '#eff6db',
      Icon: Co2
    }
  ]
  options.showMoneySaved &&
    metrics.push({
      id: 'moneySaved',
      name: 'Donated value',
      value: apiValues['money_saved__sum'] || 0, //kgForCharity * 5.7,
      unit: '$',
      color: 'mesh-green-3',
      bgcolor: 'mesh-green-3',
      Icon: Money
    })
  return metrics
}
export const groupByKeysForNivo = (data, options = {}) => {
  const generateZeroDays = (row, index, data, keyPair, endOfData) => {
    const generateRowsBetweenDates = (prevRowDate, days, zeroRows, startAt = 1) => {
      for (let i = startAt; i < days; i++) {
        const dummyRow = {}
        const dummyDate = new Date(prevRowDate)
        const newDayDate = prevRowDate.getDate() + i
        dummyDate.setDate(newDayDate)
        // dummyRow.date = dummyDate.toISOString().split('T')[0]
        dummyRow.x = dummyDate.toISOString().split('T')[0]
        dummyRow.y = 0
        dummyRow.zero = true
        zeroRows.push(dummyRow)
      }
    }
    const zeroRows = []
    if (!keyPair.xFill.addZeroDays) {
      return zeroRows
    }
    const startDate = keyPair.xFill.min && new Date(keyPair.xFill.min)
    const endDate = keyPair.xFill.max && new Date(keyPair.xFill.max)

    // fill in blank or missing data days, assumes data is ordered correctly by date
    if (keyPair.x === 'date') {
      if (index === 0 && data[0] && startDate) {
        const currentRow = data[0]
        const currentRowDate = new Date(currentRow.x)
        const days = diffBetweenDates(startDate, currentRowDate)
        generateRowsBetweenDates(startDate, days, zeroRows, 0)
      }
      if (index > 0 && !endOfData) {
        const prevRow = data[index - 1]
        if (prevRow.x !== row.x) {
          const prevRowDate = new Date(prevRow.x)
          const rowDate = new Date(row.x)
          const days = diffBetweenDates(prevRowDate, rowDate)
          // this will add extra days between the previous date and current row date
          generateRowsBetweenDates(prevRowDate, days, zeroRows)
        }
      }
      if (endOfData && endDate) {
        const currentRow = data[index - 1]
        const currentRowDate = new Date(currentRow.x)
        const days = diffBetweenDates(currentRowDate, endDate)
        generateRowsBetweenDates(currentRowDate, days + 1, zeroRows)
      }
    }
    return zeroRows
  }
  const {
    lineConfig = {
      idFn: undefined,
      keyPair: { x: undefined, y: undefined, xFill: { min: undefined, max: undefined } }
    },
    keys,
    barConfig = {
      keys: [],
      keyPair: {
        idKey: undefined,
        valueKey: undefined,
        groupByKeyValue: undefined,
        groupByFn: undefined
      }
    }
  } = options
  const groupedForLine = {}
  const groupedForPie = {}
  const groupedForBar = { keys: barConfig.keyPair.keys, data: {}, values: [] }

  // add keys

  if (data && data.length > 0) {
    // prefill object with requested key types to group under based on the first entry in data set
    // {
    //   destination_id:{}
    //   department_id:{}
    // }
    keys.forEach((key) => {
      if (key in data[0]) {
        groupedForLine[key] = {}
        groupedForPie[key] = {}
      }
    })
    let returnKeyPairOnly = false
    if (lineConfig.keyPair.x && lineConfig.keyPair.y) {
      returnKeyPairOnly = true
      if (!(lineConfig.keyPair.x in data[0] && lineConfig.keyPair.y in data[0])) {
        console.error(
          '[groupByKeys] Some keys defined in `keyPair` were not found in data supplied',
          lineConfig.keyPair,
          data[0]
        )
      }
    }
    // add row to each key type we want to group
    data.forEach((row, index) => {
      // BAR GRAPH -----------------------------------------------------------------------------
      if (barConfig.keyPair.idKey && barConfig.keyPair.keys) {
        const barRowKey = row[barConfig.keyPair.idKey]
        if (groupedForBar.data[barRowKey] === undefined) {
          groupedForBar.data[barRowKey] = {
            id: barRowKey
          }
          barConfig.keyPair.keys.forEach((key) => (groupedForBar.data[barRowKey][key] = 0))
        }
        // add keys to organize data by
        const keyAsValue = barConfig.keyPair.groupByFn(row[barConfig.keyPair.groupByKeyValue])
        groupedForBar.data[barRowKey][keyAsValue] += row[barConfig.keyPair.valueKey]
      }

      // cycle through each possible key type that we want to group under for the same data
      // i.e group by destination_id or department_id

      Object.keys(groupedForLine).forEach((key) => {
        const rowKeyValue = row[key]
        let xy = {}
        // check if this subkey exists in our object to file under, this would be the value of our
        // target key such as {...destination_id: 1} so we will add groupedForLine["destination_id"][1] = {...}
        // this also prepares the basic data structure that the graph expects
        if (!(rowKeyValue in groupedForLine[key])) {
          groupedForLine[key][rowKeyValue] = {
            data: [],
            id: lineConfig.idFn ? lineConfig.idFn(rowKeyValue) : rowKeyValue
          }
        }
        // for pie graph
        if (!(rowKeyValue in groupedForPie[key])) {
          groupedForPie[key][rowKeyValue] = {
            value: 0,
            id: lineConfig.idFn ? lineConfig.idFn(rowKeyValue) : rowKeyValue,
            label: lineConfig.idFn ? lineConfig.idFn(rowKeyValue) : rowKeyValue
          }
        }
        // this helps nivo graphing library for line graphs
        if (lineConfig.keyPair.x && lineConfig.keyPair.y) {
          xy = { x: row[lineConfig.keyPair.x], y: row[lineConfig.keyPair.y] }
        }
        const newRow = { ...(!returnKeyPairOnly && row), ...xy }

        // file this under the appropriate rowKeyValue i.e [destination_id][1].data.push({...x,..y})
        // so for destination id 1 we will snatch this from the data set and add it under id 1 which
        // is the value of destination_id in this particular row
        const newIndex = groupedForLine[key][rowKeyValue].data.length
        const zeroRows = generateZeroDays(
          newRow,
          newIndex,
          groupedForLine[key][rowKeyValue].data,
          lineConfig.keyPair
        )

        groupedForLine[key][rowKeyValue].data.push(...zeroRows.concat(newRow))
        // groupedForLine[key][rowKeyValue].data.push(newRow)
        // simple total for pie graph for this pair
        groupedForPie[key][rowKeyValue].value += row[lineConfig.keyPair.y]
      })
    })
    // fill missing days for bar graphs, easier than line
    let barData = []

    if (barConfig.keyPair.idKey && barConfig.keyPair.keys && barConfig.keyPair.xFill) {
      if (barConfig.keyPair.xFill.addZeroDays) {
        const startDate = barConfig.keyPair.xFill.min && new Date(barConfig.keyPair.xFill.min)
        const endDate = barConfig.keyPair.xFill.max && new Date(barConfig.keyPair.xFill.max)
        const zeroDataObj = {}
        barConfig.keyPair.keys.forEach((key) => (zeroDataObj[key] = 0))
        if (startDate && endDate) {
          const days = diffBetweenDates(startDate, endDate)
          const indexDate = new Date(startDate)

          for (let i = 0; i <= days; i++) {
            const dummyDate = new Date(indexDate)
            const newDayDate = indexDate.getDate() + i
            dummyDate.setDate(newDayDate)
            const dummyDateString = dummyDate.toISOString().split('T')[0]
            const barRowKey = dummyDateString
            if (groupedForBar.data[barRowKey] === undefined) {
              // groupedForBar.data[barRowKey] = {
              //   id: barRowKey,
              //   ...zeroDataObj
              // }
              barData.push(
                (groupedForBar.data[barRowKey] = {
                  id: barRowKey,
                  ...zeroDataObj
                })
              )
            } else {
              barData.push(groupedForBar.data[barRowKey])
            }
          }
        }
      } else {
        barData = Object.values(groupedForBar.data)
      }
    }
    groupedForBar.values = barData
    groupedForBar.data = {} // this was only used to fill by key (date)
    // fill zero start and end days for line graphs
    Object.keys(groupedForLine).forEach((key) => {
      Object.keys(groupedForLine[key]).forEach((rowKeyValue) => {
        if (groupedForLine[key][rowKeyValue].data.length) {
          const lastIndex = groupedForLine[key][rowKeyValue].data.length
          const zeroRowsEnd = generateZeroDays(
            groupedForLine[key][rowKeyValue].data[lastIndex - 1],
            lastIndex,
            groupedForLine[key][rowKeyValue].data,
            lineConfig.keyPair,
            true
          )
          const zeroRowsStart = generateZeroDays(
            null,
            0,
            groupedForLine[key][rowKeyValue].data,
            lineConfig.keyPair
          )
          // assemble start zero days + data + trailing zero days together
          groupedForLine[key][rowKeyValue].data = zeroRowsStart.concat(
            groupedForLine[key][rowKeyValue].data,
            zeroRowsEnd
          )
        }
      })
    })
  }
  return {
    groupedForLine: groupedForLine,
    groupedForPie: groupedForPie,
    groupedForBar: groupedForBar
  }
}
export const appendPathWithSlash = (path) => {
  if (path.endsWith('/')) {
    return path
  }
  return path + '/'
}
export const removePathWithSlash = (path) => {
  if (path.endsWith('/')) {
    return path.slice(0, -1)
  }
  return path
}
export function debounce(a, b, c) {
  let d, e
  return function () {
    function h() {
      ; (d = null), c || (e = a.apply(f, g))
    }
    const f = this,
      g = arguments
    return clearTimeout(d), (d = setTimeout(h, b)), c && !d && (e = a.apply(f, g)), e
  }
}
// see: https://stackoverflow.com/questions/7225407/convert-camelcasetext-to-sentence-case-text
export const sentenceCase = (text) => {
  const result = text.replace(/([A-Z])/g, ' $1')
  return result.charAt(0).toUpperCase() + result.slice(1)
}

export const labelByMode = (key, demoMode) => {
  const demoMapping = demoNavMapping
  return demoMode ? demoMapping[key].demoLabel : demoMapping[key].label
}
export const networkMap = {
  rdno: {
    centerOfMap: { lat: 50.44701007875901, lng: -119.19664344245324 },
    region: 'North Okanagan',
    apiArea: 'North Okanagan',
    pageTitle: 'RDNO Network Map',
    helpText: "What organizations in the RDNO have achieved to date through FoodMesh's programs and services",
    short: "RDNO",
    zoom: 10
  },
  fvrd: {
    centerOfMap: { lat: 49.04389321970851, lng: -122.2239462802915 },
    region: 'Fraser Valley',
    apiArea: 'Fraser Valley',
    pageTitle: 'FVRD Network Map',
    helpText: "What organizations in the FVRD have achieved to date through FoodMesh's programs and services",
    short: "FVRD",
    zoom: 10
  },
  cov: {
    centerOfMap: { lat: 49.2577354, lng: -123.123904 },
    region: 'City of Vancouver',
    apiArea: 'Vancouver',
    pageTitle: 'COV Network Map',
    helpText: "What organizations in the City of Vancouver have achieved to date through" +
      "FoodMesh's programs and services",
    short: "COV",
    zoom: 12
  },
  mv: {
    centerOfMap: { lat: 49.2268373, lng: -122.8190981 },
    region: 'Metro Vancouver',
    apiArea: 'Metro Vancouver',
    pageTitle: 'MV Network Map',
    helpText: "What organizations in the Metro Vancouver have achieved to date through" +
      "FoodMesh's programs and services",
    short: "MV",
    zoom: 10
  },
  all: {
    centerOfMap: {   lat: 45.0, lng: -96.0 },
    region: 'Foodmesh Network Map',
    apiArea: 'All',
    pageTitle: 'Foodmesh Network Map',
    helpText: "What organizations in the North America have achieved to date through" +
      "FoodMesh's programs and services",
    short: "All",
    zoom: 4
  }
}
export const regionsCities = {
  "FVRD": [
    "Abbotsford",
    "Chilliwack",
    "Harrison Hot Springs",
    "Hope",
    "Kent",
    "Mission",
    "Agassiz",
    "Boston Bar",
    "North Bend",
    "Canyon Alpine",
    "Yale",
    "Choate",
    "Dogwood Valley",
    "Emory Creek",
    "Laidlaw",
    "Othello",
    "Ruby Creek",
    "Spuzzum",
    "Sunshine Valley",
    "Hemlock Valley",
    "Harrison Mills",
    "Lake Errock",
    "Weaver Creek",
    "Popkum",
    "Bridal Falls",
    "Chilliwack River Valley",
    "McConnell Creek",
    "Hatzic Prairie",
    "Nicomen Island",
    "Dewdney",
    "Hatzic Island",
    "Deroche",
    "Cultus Lake",
    "Columbia Valley",
    "Lindell Beach",
  ],
  "RDNO": [
    "Armstrong",
    "Blue Springs",
    "Cherryville",
    "Coldstream",
    "Enderby",
    "Grindrod",
    "Hullcar",
    "Lumby",
    "Mara",
    "North Okanagan",
    "Spallumcheen",
    "Vernon"
  ],
  "COV": ["Vancouver"],
  "MV": [   "Vancouver",             
            "Anmore",
            "Village of Belcarra",
            "Bowen Island",
            "Burnaby",
            "Coquitlam",
            "Delta",
            "Electoral Area A",
            "Langley",
            "Township of Langley",
            "Lions Bay",
            "Maple Ridge",
            "New Westminster",
            "North Vancouver",
            "North Vancouver",
            "Pitt Meadows",
            "Port Coquitlam",
            "Port Moody",
            "Richmond",
            "Surrey",
            "Tsawwassen",
            "Vancouver",
            "West Vancouver",
            "White Rock"]
}

export const surplusMarketplaces = {
  COV: {
    Sell: [
      {
        link: 'https://app.foodmesh.ca/accounts/register/',
        label: 'FoodMesh Marketplace',
        description: 'B2B marketplace for businesses to sell their \
                large volumes of surplus food at a reduced cost'
      },
      {
        link: 'https://www.toogoodtogo.com/en-ca/business/',
        label: 'Too Good To Go',
        description: 'For grocery retailers, restaurants and cafes \
                to sell their surplus products to consumers at a reduced cost'
      },
      {
        link: 'https://www.flashfood.com/en/partners',
        label: 'Flash Foods',
        description: 'For grocery retailers to sell their close-to-expiry \
                products to consumers at a reduced costs'
      },
      {
        link: 'https://pekoproduce.com',
        label: 'Peko Produce',
        description: 'For farms and wholesalers to sell their imperfect produce\
                and surplus grocery products to consumers at a reduced cost'
      }
    ],
    Donate: [
      {
        link: 'https://app.foodmesh.ca/accounts/register',
        label: 'FoodMesh Marketplace',
        description: 'B2B marketplace for businesses to donate their large\
                volume of surplus food to a network of local charities'
      },
      {
        link: 'https://www.vancouverfoodrunners.com/donate-food',
        label: 'Vancouver Food Runners',
        description: 'For businesses to donate their surplus food\
                to a network of local charities(2 box minimum) '
      },
      {
        link: 'https://www.secondharvest.ca/our-work/food-rescue/second-harvest-food-rescue-app',
        label: 'Second Harvest Food Rescue App',
        description: 'For businesses to donate their surplus\
                food to a network of local charities'
      }
    ]
  },
  FVRD: {
    Sell: [
      {
        link: 'https://app.foodmesh.ca/accounts/register/',
        label: 'FoodMesh Marketplace',
        description: 'B2B marketplace for businesses to sell their \
                large volumes of surplus food at a reduced cost'
      },
      {
        link: 'https://www.toogoodtogo.com/en-ca/business/',
        label: 'Too Good To Go',
        description: 'For grocery retailers, restaurants and cafes \
                to sell their surplus products to consumers at a reduced cost'
      },
      {
        link: 'https://www.flashfood.com/en/partners',
        label: 'Flash Foods',
        description: 'For grocery retailers to sell their close-to-expiry \
                products to consumers at a reduced costs'
      },
      {
        link: 'https://pekoproduce.com',
        label: 'Peko Produce',
        description: 'For farms and wholesalers to sell their imperfect produce\
                and surplus grocery products to consumers at a reduced cost'
      }
    ],
    Donate: [
      {
        link: 'https://app.foodmesh.ca/accounts/register',
        label: 'FoodMesh Marketplace',
        description: 'B2B marketplace for businesses to donate their large\
                volume of surplus food to a network of local charities'
      },
      {
        link: 'https://www.secondharvest.ca/our-work/food-rescue/second-harvest-food-rescue-app',
        label: 'Second Harvest Food Rescue App',
        description: 'For businesses to donate their surplus\
                food to a network of local charities'
      }
    ]
  },
  RDNO: {
    link: 'https://foodmesh.ca/our-services/marketplace/',
    label: 'Buy, sell and donate surplus food',
    description: ''
  },
  MV: {
        Sell: [
      {
        link: 'https://app.foodmesh.ca/accounts/register/',
        label: 'FoodMesh Marketplace',
        description: 'B2B marketplace for businesses to sell their \
                large volumes of surplus food at a reduced cost'
      },
      {
        link: 'https://www.toogoodtogo.com/en-ca/business/',
        label: 'Too Good To Go',
        description: 'For grocery retailers, restaurants and cafes \
                to sell their surplus products to consumers at a reduced cost'
      },
      {
        link: 'https://www.flashfood.com/en/partners',
        label: 'Flash Foods',
        description: 'For grocery retailers to sell their close-to-expiry \
                products to consumers at a reduced costs'
      },
      {
        link: 'https://pekoproduce.com',
        label: 'Peko Produce',
        description: 'For farms and wholesalers to sell their imperfect produce\
                and surplus grocery products to consumers at a reduced cost'
      }
    ],
    Donate: [
      {
        link: 'https://app.foodmesh.ca/accounts/register',
        label: 'FoodMesh Marketplace',
        description: 'B2B marketplace for businesses to donate their large\
                volume of surplus food to a network of local charities'
      },
      {
        link: 'https://www.vancouverfoodrunners.com/donate-food',
        label: 'Vancouver Food Runners',
        description: 'For businesses to donate their surplus food\
                to a network of local charities(2 box minimum) '
      },
      {
        link: 'https://www.secondharvest.ca/our-work/food-rescue/second-harvest-food-rescue-app',
        label: 'Second Harvest Food Rescue App',
        description: 'For businesses to donate their surplus\
                food to a network of local charities'
      }
    ]
  },
  All: {
    link: 'https://foodmesh.ca/our-services/marketplace/',
    label: 'Buy, sell and donate surplus food',
    description: ''
  }
}